import { colors } from "@/styles/colors"
import * as React from "react"
import { SVGProps } from "react"

import { ReactComponent as LetalkShortLogoSvg } from "@/assets/logos/letalk_short_logo.svg"

type LetalkLogoProps = SVGProps<SVGSVGElement> & {
	isDarkLogo?: boolean
}

const LetalkVerticalLogo: React.FC<LetalkLogoProps> = (props) => {
	const { isDarkLogo, style, ...svgProps } = props
	const fill = isDarkLogo ? colors.gray[800] : colors.gray[100]

	return (
		<LetalkShortLogoSvg
			style={{ color: fill, ...style }}
			{...svgProps}
		/>
	)
}

export default LetalkVerticalLogo
